/* eslint-disable */
import { RouteRecordRaw } from "vue-router";
import routerLogin from "@/router/routes/login";
import routerFirmware from "@/router/routes/update";
import routerFaq from "@/router/routes/faq";
import routerVoc from "@/router/routes/voc";
import routerAdmin from "@/router/routes/admin";
import routerNotice from "@/router/routes/notice";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    // TODO:: 메인페이지 정해지기 전까지는 공지사항 화면으로 리다이렉트
    // name: "Main Page",
    // component: () => import(/* webpackChunkName: "home" */ "../views/main/ListView.vue"),
    // meta: { layout: DefaultLayout },
    // redirect: "/update/firmware/connect",
    redirect: "/notice",
  },
  {
    path: "/bluetooth",
    name: "Bluetooth",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/Bluetooth/HomeView.vue"),
    meta: { layout: DefaultLayout },
  },  
  ...routerLogin,
  ...routerFirmware,
  ...routerVoc,
  ...routerAdmin,
  ...routerFaq,
  ...routerNotice,
];

export {
  routes
};
